import { useLocalStorage, useRefCallback } from "@enfusion-ui/hooks";
import * as React from "react";

import { EnvironmentsContext, EnvironmentType } from "./context";

export const defaultEnvironmentOptions: EnvironmentType[] = [
  {
    label: "UAT",
    IDPUrl: "https://login-uat-us01.enfusionsystems.com/auth",
    restAPIUrl: "https://webapp-uat.enfusionsystems.com",
  },
  {
    label: "QA",
    IDPUrl: "https://login-qa-us01.enfusionsystems.com/auth",
    restAPIUrl: "https://webapp-qa.enfusionsystems.com",
  },
  {
    label: "PROD",
    IDPUrl: "https://login-prod-us01.enfusionsystems.com/auth",
    restAPIUrl: "https://webapp.enfusionsystems.com",
  },
];

export const DEFAULT_ENV = defaultEnvironmentOptions[0];

const ENV_STORAGE_KEY = "ai-tool-env";

export const EnvironmentsProvider: React.FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  const [customEnvironments, setEnvs] = useLocalStorage<EnvironmentType[]>(
    `${ENV_STORAGE_KEY}-custom`,
    []
  );

  const [authEnvironment, setAuthEnv] = useLocalStorage<EnvironmentType>(
    `${ENV_STORAGE_KEY}-auth`,
    { ...DEFAULT_ENV }
  );

  const environments = React.useMemo(
    () => [...defaultEnvironmentOptions, ...customEnvironments],
    [customEnvironments]
  );

  const setCustomEnvironments = useRefCallback((envs: EnvironmentType[]) => {
    setEnvs(envs);
  }, []);

  const setAuthEnvironment = useRefCallback((env: EnvironmentType) => {
    setAuthEnv(env);
  }, []);

  return (
    <EnvironmentsContext.Provider
      value={{
        environments,

        customEnvironments,
        setCustomEnvironments,

        authEnvironment,
        setAuthEnvironment,
      }}
    >
      {children}
    </EnvironmentsContext.Provider>
  );
};
